export default {
  install(Vue, options) {
    const store = options.store;

    const applyBlurToElement = (element) => {
      if (!store.state.presentation.presentationMode) return;
      if (!element || element.nodeType !== Node.ELEMENT_NODE) return;

      const sensitiveTexts = store.state.sensitiveTexts || [];
      if (sensitiveTexts.length === 0) return;

      const tagName = element.tagName?.toLowerCase();
      if (
        !tagName ||
        ["script", "style", "noscript", "iframe"].includes(tagName) ||
        element.classList.contains("presentation-blur-auto") ||
        element.closest(".no-auto-blur")
      ) {
        return;
      }

      const processTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (!text) return;

          const textLower = text.toLowerCase();

          for (const sensitiveText of sensitiveTexts) {
            if (textLower.includes(sensitiveText)) {
              const wrapper = document.createElement("span");
              wrapper.className = "presentation-blur-auto";
              wrapper.textContent = text;
              wrapper._originalText = text;

              node.parentNode?.replaceChild(wrapper, node);
              return true;
            }
          }
          return false;
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          const tag = node.tagName?.toLowerCase();
          if (["input", "textarea", "select", "button"].includes(tag)) {
            return false;
          }

          const children = Array.from(node.childNodes);
          for (const child of children) {
            processTextNodes(child);
          }
        }
        return false;
      };

      processTextNodes(element);
    };

    const removeAllBlurs = () => {
      document.querySelectorAll(".presentation-blur-auto").forEach((el) => {
        if (el._originalText) {
          const textNode = document.createTextNode(el._originalText);
          el.parentNode?.replaceChild(textNode, el);
        }
      });
    };

    let observer = null;

    const startObserver = () => {
      if (observer) return;

      observer = new MutationObserver((mutations) => {
        if (!store.state.presentationMode) return;

        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              applyBlurToElement(node);

              node.querySelectorAll("*").forEach((child) => {
                applyBlurToElement(child);
              });
            }
          });
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    };

    const stopObserver = () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    };

    store.subscribe((mutation) => {
      if (
        mutation.type === "TOGGLE_PRESENTATION_MODE" ||
        mutation.type === "SET_PRESENTATION_MODE" ||
        mutation.type === "SET_SENSITIVE_TEXTS"
      ) {
        const isActive = store.state.presentation.presentationMode;

        if (isActive) {
          removeAllBlurs();
          setTimeout(() => {
            document.querySelectorAll("body *").forEach((el) => {
              applyBlurToElement(el);
            });
            startObserver();
          }, 100);
        } else {
          removeAllBlurs();
          stopObserver();
        }
      }
    });

    Vue.mixin({
      mounted() {
        if (store.state.presentationMode) {
          this.$nextTick(() => {
            if (this.$el && this.$el.nodeType === Node.ELEMENT_NODE) {
              applyBlurToElement(this.$el);
            }
          });
        }
      },

      updated() {
        if (store.state.presentationMode) {
          this.$nextTick(() => {
            if (this.$el && this.$el.nodeType === Node.ELEMENT_NODE) {
              applyBlurToElement(this.$el);
            }
          });
        }
      }
    });

    Vue.prototype.$reapplyBlur = function () {
      if (store.state.presentationMode) {
        removeAllBlurs();
        setTimeout(() => {
          document.querySelectorAll("body *").forEach((el) => {
            applyBlurToElement(el);
          });
        }, 100);
      }
    };
  }
};
